document.addEventListener("DOMContentLoaded", function () {
  const popupOverlay = document.getElementById('market-language-popup');

  if (!popupOverlay) {
    console.log("Popup element not found; skipping logic.");
    return;
  }

  const isCustomizer = window.self !== window.top || window.location.search.includes('preview_theme_id');
  if (isCustomizer) return;

  const urlParams = new URLSearchParams(window.location.search);
  const redirected = urlParams.get('redirected');

  if (redirected === 'true' || sessionStorage.getItem('hasBeenRedirected') === 'true') {
    return;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'browsing_context_suggestions.json')
    .then(function(response) {
      if (!response.ok) throw new Error('Geo lookup failed');
      return response.json();
    })
    .then(function(data) {
      var countryCode = '';
      if (data && data.detected_values && data.detected_values.country && data.detected_values.country.handle) {
        countryCode = String(data.detected_values.country.handle).toUpperCase();
      }

      console.log("Detected Country Code:", countryCode);

      if (countryCode && countryCode !== 'PL') {
        sessionStorage.setItem('hasBeenRedirected', 'true');
        popupOverlay.style.display = 'flex';
      } else {
        sessionStorage.setItem('hasBeenRedirected', 'true');
        console.log("User is from Poland; popup will not be displayed.");
      }
    })
    .catch(error => console.log('Error fetching country code:', error));
});
